import React from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import {
  DeprecatedThemeOptions,
  createTheme,
  // useMediaQuery,
} from '@mui/material';

import theme, { ThemeModes } from './theme';
import { EmptyObject } from '../../react-app-env';
import useLocalStorage from '../../hooks/useLocalStorage';

interface Props extends React.PropsWithChildren<EmptyObject> {
  modes: ThemeModes,
}

interface CutsomThemeContextItems {
  darkMode: boolean,
  setDarkMode: React.Dispatch<React.SetStateAction<boolean>>;
  toggleDarkMode: () => void;
}

export const CustomThemeContext = React.createContext<CutsomThemeContextItems | null>(null);

const CutsomThemeProvider = ({ children, modes }: Props): React.ReactElement => {
  // const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [darkMode, setDarkMode] = useLocalStorage<boolean>('dark-mode', false);

  const mainTheme = createTheme(theme(darkMode, modes) as DeprecatedThemeOptions);

  const handleToggleDarkMode = () => {
    setDarkMode(i => !i);
  };

  const contextItems: CutsomThemeContextItems = {
    darkMode,
    setDarkMode,
    toggleDarkMode: handleToggleDarkMode,
  };

  return (
    <CustomThemeContext.Provider value={contextItems}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={mainTheme}>
          {children}
        </ThemeProvider>
      </StyledEngineProvider>
    </CustomThemeContext.Provider>
  );
}

export default CutsomThemeProvider;
